'use client';

import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import useReSize from '@/legacy/hooks/useBodyResize';

type Props = {
	children?: React.ReactNode;
};
type DeviceMode = 'mobile' | 'tablet' | 'desktop';

export const deviceModeAtom = atom<DeviceMode>('mobile');

export const useDeviceMode = () => {
	const value = useAtomValue(deviceModeAtom);
	return value;
};

const ResizeEvent = ({ children }: Props) => {
	// const hash = typeof window !== 'undefined' ? window.location.hash.slice(1) : ''
	const [width, height] = useReSize();
	const setMode = useSetAtom(deviceModeAtom);

	useEffect(() => {
		if (width === 0) return;

		if (width > 1216) {
			setMode('desktop');
		} else if (width > 768) {
			setMode('tablet');
		} else {
			setMode('mobile');
		}
	}, [width]);
	return <>{children}</>;
};

export default ResizeEvent;
